/**
 * Created by oe on 17/02/15.
 *
 * Constants for Gauge Store
 */

export enum Constants {
    GET_GAUGE_DATA,
    GET_GAUGE_DATA_FINISH
}
